export const environmentShared = {
  production: true,
  moduleFederationUrl: {
    shell: '/shell',
    visual: '/visualremote',
    orderPlanning: '/orderplanningremote',
    admin: '/adminremote'
  },
  logOutURL: '',
  localJson: false,
  // apiUrl: './assets/json',
  apiUrl: '',
  feedbackDates: [1, 3, 4],
  issuer: 'https://oktanp.apll.com/oauth2/default',
  clientId: '',
  appInsights: {
    instrumentationKey: ''
  }
};
